<template>
    <div>
        <ul v-if="attachmentFiles?.length">
            <li v-for="item in attachmentFiles" :key="item">
                <a href="#" @click.prevent="downloadFile(item)">{{ item?.original_name }}</a>
            </li>
        </ul>
        <div v-else>No attachments available</div>
        <loader-dialog v-if="loading" />
    </div>
</template>

<script setup>
import LoaderDialog from '../../../components/LoaderDialog.vue';

import { ref, defineProps, computed } from 'vue';
import { fileStore } from '../../../store/global-stores';
import { showToast } from '../../../utilities/toast-handler';

const props = defineProps({
    attachments: {
        type: Array,
    },
});

const loading = ref(null);

const attachmentFiles = computed(() => {
    return props.attachments?.map((attachment) => attachment.file ?? attachment);
});

const downloadFile = async (file) => {
    try {
        loading.value = true;
        await fileStore.downloadFile(file.id, file.original_name);
    } catch (error) {
        showToast(error.response, 'Unable to download the file');
    } finally {
        loading.value = false;
    }
};
</script>
